import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'resign/'

const initialState = {
    exitsList: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const getExits = createAsyncThunk('resign/gae', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getSingleExit = createAsyncThunk('resign/gse', async (advID, thunkAPI) => {
    try {
        const result = await axios.get(`${API_URL}${advID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const addExit = createAsyncThunk('resign/ane', async (advData, thunkAPI) => {
    try {
        const result = await axios.post(`${API_URL}`, advData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const editExit = createAsyncThunk('resign/ee', async (exitData, thunkAPI) => {
    try {

        const result = await axios.put(`${API_URL}${exitData.exitID}`, exitData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteExit = createAsyncThunk('resign/de', async (advID, thunkAPI) => {
    try {

        const result = await axios.delete(`${API_URL}${advID}`)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const resignSlice = createSlice({
    name: 'sal',
    initialState,
    reducers: {
        reset: (state) => {
            state.getExits = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getExits.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getExits.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.advancesList = action.payload
            })
            .addCase(getExits.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.advancesList = []
            })
            .addCase(addExit.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addExit.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(editExit.pending, (state) => {
                state.isLoading = true
            })
            .addCase(editExit.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(deleteExit.pending, (state) => {
                state.isLoading = true
            })
            .addCase(deleteExit.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(getSingleExit.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getSingleExit.fulfilled, (state, action) => {
                state.isLoading = false
            })
    }
})

export const { reset } = resignSlice.actions

export default resignSlice.reducer